import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getDataPengajuanPenerbitanSertifikat = 'data-pengajuan-penerbitan-sertifikat-rpl';
const getDataPengajuanPenerbitanSertifikatBelumDiterima = 'data-pengajuan-penerbitan-sertifikat-belum-diterima'
const getDataPengajuanPenerbitanSertifikatAjuan = 'data-pengajuan-penerbitan-sertifikat-pengajuan'
const getDetailDataPengajuanPenerbitanSertifikat = 'data-pengajuan-penerbitan-sertifikat-rpl/';
const putDataPengajuanPenerbitanSertifikat = 'data-pengajuan-penerbitan-sertifikat-rpl/';


class PengajuanPenerbitanSertifikatRplService {
    
    getData(currentPage,pageSize,filter,periode, idSertifikasi) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            periode : periode,
            id_sertifikasi: idSertifikasi
        };
        
        return axios.get(
            API_URL + getDataPengajuanPenerbitanSertifikat ,
        {
            params : data,
            headers: authHeader()
        });
    }

    getDataPengajuan(currentPage, pageSize, filter, periode, idSertifikasi) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            periode : periode,
            id_sertifikasi: idSertifikasi
        };
        
        return axios.get(API_URL + getDataPengajuanPenerbitanSertifikatAjuan, {
            params : data,
            headers: authHeader()
        });
        
    }

    getDataBelumDiterima(currentPage,pageSize,filter,periode, idSertifikasi) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            periode : periode,
            id_sertifikasi: idSertifikasi
        };
        
        return axios.get(
            API_URL + getDataPengajuanPenerbitanSertifikatBelumDiterima ,
        {
            params : data,
            headers: authHeader()
        });
    }

    getDetailData(id_pengajuan_penerbitan) {        
        return axios
        .get(
            API_URL + getDetailDataPengajuanPenerbitanSertifikat + id_pengajuan_penerbitan,
            { headers: authHeader() }
        );
    }

    putJadwalTc(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putDataPengajuanPenerbitanSertifikat + formData.id_pengajuan_penerbitan, formData,
            { headers: authHeader() }
        );
    }

}

export default new PengajuanPenerbitanSertifikatRplService();
